import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import TrustBar from './components/TrustBar';
import StatsSection from './components/StatsSection';
import WhyNeedSection from './components/WhyNeedSection';
import TrademarkTypesSection from './components/TrademarkTypesSection';
import HowWeWorkSection from './components/HowWeWorkSection';
import SuccessStories from './components/SuccessStories';
import RegistrationTimeline from './components/RegistrationTimeline';
import CTASection from './components/CTASection';
import TrademarkClassesSection from './components/TrademarkClassesSection';
import PricingSection from './components/PricingSection';
import ComparisonSection from './components/ComparisonSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);

  return (
    <div className="bg-[#041B1C]">
      <Header onOpenContactForm={openForm} />
      <HeroBanner />
      <TrustBar />
      <WhyNeedSection onOpenContactForm={openForm} />
      <TrademarkTypesSection />
      <HowWeWorkSection />
      <SuccessStories />
      <RegistrationTimeline />
      <CTASection onOpenContactForm={openForm} heading="Ready to Lock Down Your Brand Name?" buttonText="Start Registration Now" variant="green" />
      <TrademarkClassesSection />
      <PricingSection onOpenContactForm={openForm} />
      <ComparisonSection onOpenContactForm={openForm} />
      <WhyChooseUsSection onOpenContactForm={openForm} />
      <TestimonialsSection />
      <FAQSection onOpenContactForm={openForm} />
      <CTASection onOpenContactForm={openForm} heading="Your Brand Name Deserves Federal Protection." buttonText="Register Your Brand Name" variant="white" />
      <Footer onOpenContactForm={openForm} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
